import { Link } from 'react-router-dom';
import PageHero from '../layout/PageHero';

function Masthead() {
  return (
    <PageHero
      variant="home"
      showStripes
      eyebrow="Smart Automatisch Trace Engineering"
      title="SATE"
      subtitle="Automatisch tracé ontwerp op basis van omgevingsdata, KLIC-informatie en projectvoorwaarden."
    >
      <Link className="c-hero__cta" to="/projects">
        Mijn projecten
      </Link>
    </PageHero>
  );
}

export default Masthead;
